import { QueryClient } from '@tanstack/react-query';

// The planner app's single query client. It lives in its own module so code outside React
// (Zustand store actions) can read and write the same cache the components render from.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Global error handler for all queries - replaces individual onError callbacks
            throwOnError: false,
            // Treat data as fresh for 5 minutes — prevents unnecessary re-fetches on
            staleTime: 5 * 60 * 1000,
            // Keep inactive query data in cache for 10 minutes
            gcTime: 10 * 60 * 1000,
        },
        mutations: {
            // Mutations can still use onError in v5
            throwOnError: false,
        },
    },
});
